import React from 'react';

import Minefield from "./Minefield";

import './App.scss';

function App() {
  return (
    <section className="main-section">
      <Minefield />
    </section>
  );
}

export default App;
